import { configs } from "configs/config";
import { axios } from "utils/axios";
import { IRegProvince } from "types/reg-province.d";

export const getRegProvinces = () => {
  return axios.get<IRegProvince[]>(
    `${configs.apiUrl}/bpmp2/Utilities/RegProvince`
  );
};
